module.exports = __webpack_public_path__ + "static/img/财务问数分析智能体.0d3c341.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/operationDecision/财务问数分析智能体.jpg
// module id = JGoT
// module chunks = 0